// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3Ipsv","paramInput":"JobSimulator_paramInput__1KjXb","input":"JobSimulator_input__2KMQN"};